import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class N58SocketService implements OnDestroy {
  private socket: Socket | null = null;
  private connected$ = new BehaviorSubject<boolean>(false);
  private health$ = new Subject<any>();
  private movementNew$ = new Subject<any>();
  private movementStats$ = new Subject<any>();
  private syncStatus$ = new Subject<any>();
  private accountsUpdated$ = new Subject<any[]>();

  constructor(private cognito: CognitoService) {}

  async connect(): Promise<void> {
    if (this.socket?.connected) return;

    const session = await this.cognito.getSession();
    const token = session?.idToken?.jwtToken;
    if (!token) return;

    const baseUrl = environment.apiNest.replace(/\/+$/, '');

    this.socket = io(`${baseUrl}/n58`, {
      auth: { token },
      transports: ['polling'],
    });

    this.socket.on('connect', () => this.connected$.next(true));

    this.socket.on('disconnect', async () => {
      this.connected$.next(false);
      const newSession = await this.cognito.getSession();
      const newToken = newSession?.idToken?.jwtToken;
      if (newToken && this.socket) {
        this.socket.auth = { token: newToken };
      }
    });

    this.socket.on('n58:health', (data: any) => this.health$.next(data));
    this.socket.on('n58:movement:new', (data: any) => this.movementNew$.next(data));
    this.socket.on('n58:movement:stats', (data: any) => this.movementStats$.next(data));
    this.socket.on('n58:sync:status', (data: any) => this.syncStatus$.next(data));
    this.socket.on('n58:accounts:updated', (data: any[]) => this.accountsUpdated$.next(data));
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
    this.connected$.next(false);
  }

  isConnected$(): Observable<boolean> {
    return this.connected$.asObservable();
  }

  onHealth$(): Observable<any> {
    return this.health$.asObservable();
  }

  onMovementNew$(): Observable<any> {
    return this.movementNew$.asObservable();
  }

  onMovementStats$(): Observable<any> {
    return this.movementStats$.asObservable();
  }

  onSyncStatus$(): Observable<any> {
    return this.syncStatus$.asObservable();
  }

  onAccountsUpdated$(): Observable<any[]> {
    return this.accountsUpdated$.asObservable();
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
